import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '@ant-design/icons';
import { InfoIcon } from '@tools/ui/assets';
import { theme } from '@tools/ui-utils/theme.util';
import { RECORD_PANEL_QUERY_PARAM_TRIGGER } from '../../../consts/reco.const';
import useQueryParams from '../../../hooks/useQueryParams.hook';

type IProps = {
  bankRecordId?: string;
};

const ClickableTag = styled.div`
  cursor: pointer;
  color: ${theme.colors.blue.geekblue1};

  &:hover {
    color: ${theme.colors.blue.blue5};
  }
`;

const RelatedBankRecordCell: FC<React.PropsWithChildren<IProps>> = ({
  bankRecordId
}) => {
  const history = useHistory();
  const queryParams = useQueryParams();

  if (!bankRecordId) {
    return null;
  }

  const openBankRecordPanel = () => {
    queryParams.set(RECORD_PANEL_QUERY_PARAM_TRIGGER, bankRecordId);
    history.push({ search: queryParams.toString() });
  };

  return (
    <ClickableTag onClick={openBankRecordPanel}>
      <Icon component={InfoIcon} />
    </ClickableTag>
  );
};

export default RelatedBankRecordCell;
